import PropTypes from 'prop-types'
import React from 'react'

import { createMedia } from '@artsy/fresnel'
import DesktopContainer from './DesktopContainer'
import MobileContainer from './MobileContainer'

const AppMedia = createMedia({
  breakpoints: {
    zero: 0,
    tablet: 768,
    full: 1600,
  },
})

const mediaStyles = AppMedia.createMediaStyle()
const { Media, MediaContextProvider } = AppMedia

const ResponsiveContainer = ({ children }) => {
  return (
    <>
      <style>{mediaStyles}</style>
      <MediaContextProvider>
        <Media greaterThanOrEqual="tablet">
          <DesktopContainer>{children}</DesktopContainer>
        </Media>

        <Media lessThan="tablet">
          <MobileContainer>{children}</MobileContainer>
        </Media>
      </MediaContextProvider>
    </>
  )
}

ResponsiveContainer.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ResponsiveContainer
